import http from '@/utils/ajax'
import {
  MATCHING_INIT_LOADING,
  MATCHING_INIT_SUCCESS,
  MATCHING_INIT_FAIL,
  BATCH_MATCH_TRANS_INIT_LOADING,
  BATCH_MATCH_TRANS_INIT_SUCCESS,
  BATCH_MATCH_TRANS_INIT_FAIL,
  PERFORM_MATCH_INIT_LOADING,
  PERFORM_MATCH_INIT_SUCCESS,
  PERFORM_MATCH_INIT_FAIL
} from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async matchingInit({ commit, rootState }) {
    commit(MATCHING_INIT_LOADING)
    const apiUrl = rootState.app.menu.matching
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let commitResult = {
          menu: menu
        }
        commit(MATCHING_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(MATCHING_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(MATCHING_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async batchMatchTransInit({ commit, state }) {
    commit(BATCH_MATCH_TRANS_INIT_LOADING)
    const apiUrl = state.menu.batchMatchTrans
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let commitResult = {
          menu: menu
        }
        commit(BATCH_MATCH_TRANS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(BATCH_MATCH_TRANS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(BATCH_MATCH_TRANS_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async performMatchInit({ commit, state }) {
    commit(PERFORM_MATCH_INIT_LOADING)
    const apiUrl = state.menu.performMatch
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let commitResult = {
          menu: menu
        }
        commit(PERFORM_MATCH_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PERFORM_MATCH_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PERFORM_MATCH_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
